import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface SaveConfirmDialogData {
  title: string;
  message: string;
  saveText?: string;
  discardText?: string;
  cancelText?: string;
}

export type SaveConfirmDialogResult = 'save' | 'discard' | 'cancel';

@Component({
  selector: 'app-save-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <div class="app-dialog save-confirm-dialog">
      <div class="app-dialog__heading">
        <button mat-icon-button type="button" class="save-confirm-dialog-close" aria-label="Close" (click)="onCancel()">
          <mat-icon>close</mat-icon>
        </button>
        <div class="app-dialog__heading-copy">
          <span class="app-dialog__eyebrow">Confirmation</span>
          <div class="app-dialog__title-row">
            <div class="app-dialog__title-copy">
              <h2 mat-dialog-title class="app-dialog__title">{{ data.title }}</h2>
              <p>Review your changes before continuing.</p>
            </div>
          </div>
        </div>
      </div>
      <mat-dialog-content class="app-dialog__content">
        <section class="app-dialog__section">
          <p>{{ data.message }}</p>
        </section>
      </mat-dialog-content>
      <mat-dialog-actions class="app-dialog__actions" align="end">
      <button mat-button (click)="onCancel()">{{ data.cancelText || 'Cancel' }}</button>
      <button mat-button color="warn" (click)="onDiscard()">{{ data.discardText || 'Discard' }}</button>
      <button mat-raised-button color="primary" (click)="onSave()">{{ data.saveText || 'Save' }}</button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .save-confirm-dialog-close {
      position: absolute !important;
      top: 12px !important;
      right: 16px !important;
      z-index: 2 !important;
      color: var(--text-secondary);
    }

    .save-confirm-dialog .app-dialog__content {
      min-width: 0;
      width: 100%;
      box-sizing: border-box;
    }
  `]
})
export class SaveConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SaveConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SaveConfirmDialogData
  ) {}

  onSave(): void {
    this.dialogRef.close('save' as SaveConfirmDialogResult);
  }

  onDiscard(): void {
    this.dialogRef.close('discard' as SaveConfirmDialogResult);
  }

  onCancel(): void {
    this.dialogRef.close('cancel' as SaveConfirmDialogResult);
  }
}
